module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view",
    staticStyle: {
      "height": "100%"
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view', {
    staticClass: "view",
    staticStyle: {
      "height": "100%"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toast', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toast.show),
      expression: "toast.show"
    }],
    attrs: {
      "text": _vm.toast.message
    }
  }), _vm._v(" "), _c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    attrs: {
      "text": _vm.loading.message
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e4de8b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 823
// module chunks = 34